import { render, staticRenderFns } from "./ModalMaterialsRequest.vue?vue&type=template&id=7b195001"
import script from "./ModalMaterialsRequest.vue?vue&type=script&lang=js"
export * from "./ModalMaterialsRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports